module.exports = __webpack_public_path__ + "assets/img/0225.ba2e1d14.svg";